import { render } from "./FixedBandle.vue?vue&type=template&id=630926b6"
import script from "./FixedBandle.vue?vue&type=script&lang=js"
export * from "./FixedBandle.vue?vue&type=script&lang=js"

import "./FixedBandle.vue?vue&type=style&index=0&id=630926b6&lang=css"

import exportComponent from "/buddy/vue-calendar-bundle-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__